import { BehaviorSubject } from "rxjs";

type MapFn<TModel, TMapped> = (item: TModel) => TMapped;

export class LocalItemStore<TModel extends { [key: string]: any }, TMapped extends { [key: string]: any } = TModel> {

  readonly stateSubject = new BehaviorSubject<TMapped | null>(null);
  get state() {
    return this.stateSubject.value;
  }

  private _map: MapFn<TModel, TMapped>

  get map() {
    return this._map
  }

  set map(value: MapFn<TModel, TMapped>) {
    this._map = value;
  }


  constructor() {

  }

  replace(replace: TModel) {
    this.stateSubject.next(this._mapOne(replace))
  }


  //todo revisit
  replaceDiffs(replace: Partial<TModel>) {

    if (!this.state) {
      this.stateSubject.next(this._mapOne(replace as TModel));
      return
    }
    const newState = { ...this.stateSubject.value };

    if (!replace) {
      return;
    }

    Object
      .entries(this._mapOne(replace as any))
      .forEach(([key, value]) => {
        if (value !== newState[key]) {
          (newState as any)[key] = value;
        }
      })

    this.stateSubject.next(newState);
  }

  reset() {
    this.stateSubject.next(null);
  }


  dispose() {
    this.stateSubject.complete();
  }

  private _mapOne(item: TModel) {

    return this._map ? this._map(item) : item as unknown as TMapped
  }

}
